export default "__VITE_ASSET__8gMHM0lI__"